export default "__VITE_ASSET__C$1h_k_$__"